import React, { useState, useEffect } from "react";
import api from "../../utils/api";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Modal, { defaultStyles } from "react-modal";
import ModalContent from "./../../common/Modal/ModalContent";
import close_modal from "./../../assets/ic_close_wh.svg";
import { toast } from "react-toastify";
import { Button } from "../../common/Button/Button";
const ReactTableFixedColumns = withFixedColumns(ReactTable);


export default function AdminExpertCalendarContainer() {
  const [ExpertPartner, setExpertPartner] = useState();
  const [ExpertName, setExpertName] = useState('')
  const [ExpertID, setExpertId] = useState('')
  const [data, setData] = useState()
  const [updateSlotDay, setUpdateSlotDay] = useState("")
  const [newSlotDay, setNewSlotDay] = useState("")


  useEffect(() => {
    ExpertCalenderData();
  }, []);

  const ExpertCalenderData = () => {
     api.getAllExpertCalenderList()
      .then(({ data = [] }) => {

        const sortedExperts = [...data].sort((a, b) =>
          a.refExternalServicePartner
            .toLowerCase()
            .localeCompare(b.refExternalServicePartner.toLowerCase())
        );

        setExpertPartner(sortedExperts);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    // getDatabyID()
    // ExpertCalenderData()
    // if (ExpertPartner) {
    //     ExpertPartner.filter((ele) => ((ele.refExternalServicePartner === ExpertName) ? setId(ele.refExternalServicePartner_id) : ""))
    //     console.log("useEffectID", id)
    // }
    setTimeout(() => {
        if (ExpertID) {
            // axios.get(`https://stagewebadmin.deasra.in:8050/server/get-expert-calender/${id}/`, {
            //     headers: {
            //         Authorization: "Token 11c2e5f0fc3aa6e71c5c5fc5211bd3ce692829a3"
            //     }
            // })
            api.getExpertById(ExpertID)
                .then((res) => {
                    // alert(res.data)
                    setData(res.data)
                })
        }
    }, 500);
}, [ExpertID, ExpertName])

  // let Expert_name; 
  // let Expert_id;


  const updateSlot = (ele) => {
    setExpertName(ele.refExternalServicePartner)
    setExpertId(ele.refExternalServicePartner_id)
    // Expert_id = ele.refExternalServicePartner_id

    console.log("hjaj==", ExpertName, ExpertID)
  }

  const [expertTime, setExpertTime] = useState("")
  const [newSlotTime, setNewSlotTime] = useState("")
  // const [oldSlotId, setOldSlotId] = useState("")

  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"]
  
  const slotList = ['10:00-11:00 AM','11:00-12:00 PM','12:00-01:00 PM','01:00-02:00 PM','02:00-03:00 PM','03:00-04:00 PM','04:00-05:00 PM','05:00-06:00 PM']


  let timeSlot = [];

    if (data) {
        console.log("GK==", data)
      data.filter((ele) => ele.day === updateSlotDay ? timeSlot.push({label: ele.time , value: ele.id}) : ""
        );

    }
  
  console.log("timessakd==", timeSlot)

  let idSlot= '';

  if (timeSlot) {
    timeSlot.filter((element) => element.label === expertTime ? idSlot =element.value : "")
  }

  // useEffect(() => {
  //   setTimeout(() => {
  //     changeDays()
  //   },2000)
  // }, [updateSlotDay])
  // console.log(updateSlotDay)

  // const changeDays = (e) => {
  //   // console.log(e.target.value)
  //   setUpdateSlotDay(e.target.value)
    
  // }
  
  const changeDays = ({ target }) => {
    const {value} = target
    setUpdateSlotDay(value)
    setExpertTime("")
    setNewSlotDay("")
    setNewSlotTime("")
  }

  const changeDays1 = ({ target }) => {
    const {value} = target
    setNewSlotDay(value)
  }

  console.log(updateSlotDay, expertTime, newSlotDay, newSlotTime, idSlot)

  const expertColumns = [
    {
      headerStyle: {
        whiteSpace: "unset",
        borderBottom: "solid 1px #ccc",
        textAlign: "center",
      },
      Header: "Expert Names",
      accessor: "refExternalServicePartner",
      style: { whiteSpace: "unset", textAlign: "center" },
      // width: 100,
    },
    {
      headerStyle: {
        whiteSpace: "unset",
        borderBottom: "solid 1px #ccc",
        width: "20%",
        textAlign: "center",
      },
      style: { whiteSpace: "unset", textAlign: "center" },
      Header: "Monday",
      accessor: "calender_slots",
      Cell: ({ original }) => (
        <>
          <span>
            {original.calender_slots.map((ele, index) => {
              {
                return ele.day === "Monday" ? <div key={index}> {ele.time} </div> : "";
              }
              // return ele.day
            })}
          </span>
          {/* <span>{original["calen"]}</span> */}
        </>
      ),
    },
    {
      headerStyle: {
        whiteSpace: "unset",
        borderBottom: "solid 1px #ccc",
        width: "20%",
        textAlign: "center",
      },
      style: { whiteSpace: "unset", textAlign: "center" },
      Header: "Tuesday",
      accessor: "calender_slots",
      Cell: ({ original }) => (
        <>
          <span>
            {original.calender_slots.map((ele, index) => {
              {
                return ele.day === "Tuesday" ? <div key={index}> {ele.time} </div> : "";
              }
              // return ele.day
            })}
          </span>
          {/* <span>{original["calen"]}</span> */}
        </>
      ),
    },
    {
      headerStyle: {
        whiteSpace: "unset",
        borderBottom: "solid 1px #ccc",
        width: "20%",
        textAlign: "center",
      },
      style: { whiteSpace: "unset", textAlign: "center" },
      Header: "Wednesday",
      accessor: "calender_slots",
      Cell: ({ original }) => (
        <>
          <span>
            {original.calender_slots.map((ele, index) => {
              // let a = []
              // a.push(ele.time)
              // console.log("NEWWWWW",a)
              return ele.day === "Wednesday" ? <div key={index}> {ele.time} </div> : "";
            })}
          </span>
        </>
      ),
    },
    {
      headerStyle: {
        whiteSpace: "unset",
        borderBottom: "solid 1px #ccc",
        width: "20%",
        textAlign: "center",
      },
      style: { whiteSpace: "unset", textAlign: "center" },
      Header: "Thursday",
      accessor: "calender_slots",
      Cell: ({ original }) => (
        <>
          <span>
            {original.calender_slots.map((ele, index) => {
              {
                return ele.day === "Thursday" ? <div key={index}> {ele.time} </div> : "";
              }
              // return ele.day
            })}
          </span>
          {/* <span>{original["calen"]}</span> */}
        </>
      ),
    },
    {
      headerStyle: {
        whiteSpace: "unset",
        borderBottom: "solid 1px #ccc",
        width: "20%",
        textAlign: "center",
      },
      style: { whiteSpace: "unset", textAlign: "center" },
      Header: "Friday",
      accessor: "calender_slots",
      Cell: ({ original }) => (
        <>
          <span>
            {original.calender_slots.map((ele, index) => {
              {
                return ele.day === "Friday" ? <div key={index}> {ele.time} </div> : "";
              }
              // return ele.day
            })}
          </span>
          {/* <span>{original["calen"]}</span> */}
        </>
      ),
    },
    // {
    //   headerStyle: {
    //         whiteSpace: "unset",
    //         borderBottom: "solid 1px #ccc",
    //         textAlign: "center",
    //       },
    //   Header: "",
    //   Cell: (e) => {
    //     console.log("Clicked==")
    //     return <a href="">{ ""}</a>
    //       }
    // },
    // {
    //   headerStyle: {
    //     whiteSpace: "unset",
    //     borderBottom: "solid 1px #ccc",
    //     textAlign: "center",
    //   },
    //   Header: "",
    //   Cell: ({ original }) => (
    //     <>
    //       <span>
    //         {/* {
    //                         original.calender_slots.map((ele) => {
    //                             {
    //                                 return ele.day === "Friday" ? <div> {ele.time} </div> : ""

    //                             }
    //                             // return ele.day 



    //                         }
    //                         )
    //                     } */}
    //         <button
    //           className="my-services-model-submit-btn"
    //           onClick={() => {
    //             console.log(original);
    //             updateSlot(original)
    //             setModalIsOpenToTrue()
    //           }}
    //         >
    //           Update Slot
    //         </button>
    //       </span>
    //       {/* <span>{original["calen"]}</span> */}
    //     </>
    //   ),
    //   accessor: "refExternalServicePartner",
    //   style: { whiteSpace: "unset", textAlign: "center" },
    //   // width: 100,
    // },
    // {
    //     headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
    //     style: { 'whiteSpace': 'unset' },
    //     Header: "Tuesday",
    //     accessor: "calender_slots",
    // },
    // {
    //     headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
    //     style: { 'whiteSpace': 'unset' },
    //     Header: "Wednesday",
    //     accessor: "calender_slots.day",
    // },
    // {
    //     headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
    //     style: { 'whiteSpace': 'unset' },
    //     Header: "Thursday",
    //     accessor: "calender_slots.time",
    // },
    // {
    //     headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
    //     style: { 'whiteSpace': 'unset' },
    //     Header: "Friday",
    //     accessor: "calender_slots.time",
    // },
    // {
    //     headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '10%' },
    //     style: { 'whiteSpace': 'unset' },
    //     Header: "Slots Available",
    //     accessor: "time",
    // }
  ];

  const [modalIsOpen, setModalIsOpen] = useState(false)

  const setModalIsOpenToTrue = () => {
    setModalIsOpen(true)
  }

  const setModalIsOpenToFalse = () => {
    setModalIsOpen(false)
    setUpdateSlotDay('')
    setExpertTime("")
    setNewSlotDay("")
    setNewSlotTime("")

  }

  const updateTimeslot = () => {
    if (!updateSlotDay) {
      toast("Please Select Existing Slot Day", {
        type: toast.TYPE.ERROR,
      })
    } else if (!expertTime) {
      toast("Please Select Existing Slot Time", {
        type: toast.TYPE.ERROR,
      })
    } else if (!newSlotDay) {
      toast("Please Select New Slot Day", {
        type: toast.TYPE.ERROR,
      })
    } else if (!newSlotTime) {
      toast("Please Select New Slot Time", {
        type: toast.TYPE.ERROR,
      })
    } else {
      let payload = {
        id: idSlot,
        day: newSlotDay,
        time: newSlotTime
      }

      console.log("Payload==", payload)
      toast("Expert Slot Updated Successfully", {
        type: toast.TYPE.SUCCESS,
        autoClose: 5000
      })
      setTimeout(() => {
        setModalIsOpenToFalse()
      },2000)
    }
  }


  return (
    <>
      
      <div className="mt-5">
      <button className="my-services-model-submit-btn" style={{
                                margin: '10px'
                            }}>
        <a href="/home/admin-expert-slots" style={{
          textDecoration: "none",
          color: "white"
        }}>Edit Expert Slots</a>
    </button>
        <ReactTableFixedColumns
          minRows={0}
          data={ExpertPartner}
          columns={expertColumns}
          style={{ overflowY: "initial", height: "600px" }}
          className="-striped hide-scrollbar overflowcss"
        />
      </div>
      <Modal isOpen={modalIsOpen}>
        <ModalContent className="general-modal">
          <div className="modal-header">
            <span className="modal-title">Update Expert Slot</span>
            <img
              alt="close"
              id="Close"
              src={close_modal}
              className="close modal-close"
              onClick={setModalIsOpenToFalse}
            />
          </div>
          <div className="modal-body">
            <div className="expert-details">
              <span className="spled-colored-label" style={{ padding: '15px' }}>
                Expert Name :
              </span>
              <span className="spled-info-title">
                {ExpertName}
              </span>

              <div>
                <span className="spled-colored-label" style={{ padding: '15px' }}> Expert ID: </span> <span className="spled-black-text">{ExpertID}</span>
              </div>

              <div className="row">
                <div className="col-6">
                <label className="my-services-model-value" style={{
                                            marginTop: '25px'
                  }}>Select Day of Existing Slot: </label>
                  <select
                    style={{
                      width: "65%",
                      height: '40px',
                      padding: '5px'
                  }}
                    onChange={changeDays}
                    // value={updateSlotDay}
                  >
                    <option value="updateDay" selected disabled>Select an Option</option>
                  {
                    days.map((ele, index) => {
                      return <option key={index}>{ele}</option>
                    })
                  }
                </select>
                </div>
                
                <div className="col-6">
                                        <label className="my-services-model-value" style={{
                                            marginTop: '25px'
                                        }}>Select Time of Existing Slot: </label>
                                        <select style={{
                                            width: "65%",
                                            height: '40px',
                                            padding: '5px'
                                        }}
                                            onChange={({ target }) => {
                                              console.log("Target==",target)
                                                setExpertTime(target.value)
                                            }}
                                            value={expertTime ? expertTime : "new"}
                                            required
                                        >
                                            <option value="new" selected disabled>Select an Option</option>
                                            {
                                                timeSlot.map((ele, id) => {
                                                  return <option key={id}>{ele.label}</option>
                                                })
                                            }
                                        </select>
                                    </div>
              </div>

              <div className="row">
                <div className="col-6">
                <label className="my-services-model-value" style={{
                                                marginTop: '25px',
                                                textAlign: 'center'
                  }}>Select Day of New Slot: </label>
                  <select
                    style={{
                      width: "65%",
                      height: '40px',
                      padding: '5px'
                  }}
                    onChange={changeDays1}
                    value={newSlotDay ? newSlotDay : "newDay"}
                  >
                    <option value="newDay" selected disabled>Select an Option</option>
                  {
                    days.map((ele, index) => {
                      return <option key={index}>{ele}</option>
                    })
                  }
                </select>
                </div>

                <div className="col-6">
                <label className="my-services-model-value" style={{
                                                marginTop: '25px',
                                                textAlign: 'center'
                  }}>Select Time of New Slot: </label>

                <select
                    style={{
                      width: "65%",
                      height: '40px',
                      padding: '5px'
                  }}
                    onChange={({ target }) => {
                      setNewSlotTime(target.value)
                    }}
                    value={newSlotTime ? newSlotTime : "newTimeSlot"}
                  >
                    <option value="newTimeSlot" selected disabled>Select an Option</option>
                  {
                    slotList.map((ele, index) => {
                      return <option key={index}>{ele}</option>
                    })
                  }
                </select>

                </div>
              </div>
              <div style={{
                                    margin: '20px',
                                    textAlign: 'center'
                                }}>
                  {/* <Button className="text-center"
                    // onClick={() => {

                    //                     bookExpert()
                    // }}
                  >Book Appointment</Button> */}
                <button className="my-services-model-submit-btn"
                onClick={updateTimeslot}>
                  Update Slot
                </button>
                                </div>
                
                
            </div>
          </div>
        </ModalContent>
      </Modal>
    </>
  );
}
